/* eslint-disable no-undef */
import React from 'react';
import { Flex, Button, Heading, Image, Text } from 'rebass';
import closeIcon from 'assets/icons/close.png';
import styled from 'styled-components';
import Form from 'components/Form';
import Field from 'components/Field';
import paperclipIcon from 'assets/icons/paperclip.png';
import deleteAttachmentsIcon from 'assets/icons/deleteAttachments.png';
import { useSelector } from 'react-redux';
import ErrorMessage from 'components/ErrorMessage';
import { startAttachedFileSubmit, resolveAttachedFileSubmit } from './actions';
import ModalContent from '../ModalContent';

const FormButton = styled(Button)`
  width: 150px;
  font-size: 14px;
  padding-top: 10px;
  padding-bottom: 10px;
`;

const Content = styled(ModalContent)`
  flex-direction: column;
  padding: 35px;
`;

interface AttachFileProps {
  closeModalHandler: VoidFunction;
}

const AttachFile: React.FC<AttachFileProps> = ({ closeModalHandler }) => {
  const {
    label,
    attachedFileType,
    attachedFilePropName,
    stageId,
    stageTitle,
    candidateId,
    jobId,
  } = useSelector<any, any>(state => state.modal.data);

  return (
    <Content>
      <Flex width="100%" justifyContent="flex-end" mb={1} onClick={closeModalHandler}>
        <Image src={closeIcon} css="cursor: pointer" />
      </Flex>
      <Heading fontSize="26px" textAlign="center" mb={2}>
        {label}
      </Heading>
      <Form
        startSubmitAction={startAttachedFileSubmit().type}
        resolveSubmitAction={resolveAttachedFileSubmit().type}
        setPayload={(action: object, payload: any) => ({
          ...action,
          payload: {
            ...payload,
            attachedFileType,
            attachedFilePropName,
            candidateId,
            stageId,
            stageTitle,
            jobId,
          },
        })}
      >
        {(formProps: any) => {
          const { form, values, submitting, submitErrors } = formProps;

          return (
            <Flex flexDirection="column" alignItems="center">
              {submitErrors && <ErrorMessage>{submitErrors.data.error.message}</ErrorMessage>}
              <Flex width="100%" flexDirection="column" css="max-width: 350px;">
                {values.attachedFile ? (
                  <Flex alignItems="center" justifyContent="center">
                    <Image src={paperclipIcon} mr={1} />
                    <Text>{values.attachedFile.name}</Text>
                    <Image
                      src={deleteAttachmentsIcon}
                      ml={1}
                      onClick={() => {
                        form.change('attachedFile', undefined);
                      }}
                      css="cursor: pointer;"
                    />
                  </Flex>
                ) : (
                  <Flex alignItems="center" justifyContent="center">
                    <Field
                      name="attachedFile"
                      inputType="file"
                      fileInputText="Upload"
                      changeHandler={form.change}
                    />
                  </Flex>
                )}
              </Flex>
              <FormButton type="submit" variant={submitting ? 'disabled' : 'primary'} mt={2}>
                Submit
              </FormButton>
            </Flex>
          );
        }}
      </Form>
    </Content>
  );
};

export default AttachFile;
